import TodaysGoalsSingle from "./TodaysGoalsSingle"
export default TodaysGoalsSingle
